const constants = {
  MESSAGE_SENT: 'message_sent_done',
};

module.exports = constants;
